import numberToFixed from './numberToFixed'

interface IFormatMoneyParams {
  value: number
  maximumFractionDigits?: number
}

export default function formatMoney({
  maximumFractionDigits = 2,
  value,
}: IFormatMoneyParams) {
  return numberToFixed(value, maximumFractionDigits).toLocaleString('ru-RU', {
    currency: 'RUB',
    maximumFractionDigits,
  })
}
